import * as React from 'react';

import {
  withStyles,
  WithStyles,
  createStyles,
  Theme,
} from '@material-ui/core/styles';

import { IntlProps } from 'ha/i18n';
import Button from 'ha/ui/next/Button';
import Track from 'ha/components/track/SmartTrack';
import SvgIcon from 'ha/ui/next/SvgIcon';
import MapIcon from 'streamline-icons/maps.svg';
import Hidden from 'ha/ui/next/Hidden';
import Grid from 'ha/ui/next/Grid';

const styles = (theme: Theme) =>
  createStyles({
    mapIcon: {
      stroke: theme.palette.grey[500],
      height: '1rem',
      width: '1rem',
      marginRight: '0.5rem',
    },
  });

interface OwnProps {
  toggleMobileMap: () => void;
  toggleMapAutoSearch: (enableAutoSearch: boolean) => void;
}

type Props = OwnProps & IntlProps;

export class ToggleMobileMap extends React.Component<
  Props & WithStyles<typeof styles>
> {
  handleClick = () => {
    const { toggleMobileMap, toggleMapAutoSearch } = this.props;

    toggleMapAutoSearch(false);
    toggleMobileMap();
  };

  render() {
    const {
      intl: { T },
      classes,
    } = this.props;

    return (
      <Track name="Clicked Map view button in Search" type="button">
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={this.handleClick}
        >
          <Grid container alignItems="center">
            <Hidden mdUp>
              <SvgIcon className={classes.mapIcon}>
                <MapIcon />
              </SvgIcon>
            </Hidden>
            {T('Map')}
          </Grid>
        </Button>
      </Track>
    );
  }
}

export default withStyles(styles)(ToggleMobileMap);
